export enum WarrantyDocumentType {
  OWN_CHECK = 1,
  ONE_GUARANTOR = 2,
  TWO_GUARANTORS = 3,
  OWN_CHECK_SINGLE_GUARANTOR = 4,
  OWN_CHECK_TWO_GUARANTORS = 5,
}

export interface ILoanRequestRuleResponse {
  need_extra_document: boolean;
  cheque_receipt_date: string; // YYYY-MM-DD

  owner_first_cheque_price: number;
  owner_second_cheque_price: number;
  owner_third_cheque_price: number;

  first_guarantor_cheque_price: number;
  second_guarantor_cheque_price: number;

  warranty_document_type: WarrantyDocumentType;

  receiver_name: string;
  national_id: string;
}
